const runAfterConsent = require("./utils/runAfterConsent.js");
const runConsentEvent = require("./utils/runConsentEvent.js");
const getConsentDeniedValues = require("./utils/getConsentDeniedValues");

const consent = {
  init: runAfterConsent,
  run: runConsentEvent,
  getDeniedValues: getConsentDeniedValues
};

module.exports = { consent };
